import { render, staticRenderFns } from "./StudiengangName.vue?vue&type=template&id=e95fe77e"
import script from "./StudiengangName.vue?vue&type=script&lang=js"
export * from "./StudiengangName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports